// removed by extract-text-webpack-plugin
module.exports = {"page":"_2S1FC9fW0 _30W7J4cYZ gkmejKHip","centered":"_39sgJWuw5 _3EiT4eWlg _2Kz2o9zH0 _1FoUCLbbD _2l0xl0HVf _2nov6tC6P","iframe":"CnRp8VlxW _3mbDdE65I _29PZxIOm7 _2l0xl0HVf","iframe--loading":"yakDwosuI _2gtf48bQr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/iframe-page/iframe-page.css
 ** module id = 2192
 ** module chunks = 0
 **/